<template>
  <!-- 阅读器的文本页面 -->
  <div v-if="pb==='豎排'" id="read_right"  class="text_box">
    <div style="zoom: 0.35;font-size: 40px;" v-for="(child,childIndex) in item.list" :key="childIndex" class='text' :style="{
    left:child.box[0]+'px',
    marginTop: child.box[1]+'px'
      }">{{' '+ child.text +' '}}</div>
  </div>
  <div v-else class="text_box" style="display: block;">
    <span v-for="(child,childIndex) in item.list" :key="childIndex" :style="{
      }">{{' '+ child.text +' '}}</span>
  </div>
</template>

<script>
  export default {
    props:['item','pb']
  }
</script>

<style>
  .text_box {
    position: relative;
    display: flex;
    font-size: 16px;
    width: 11.947rem;
    height: 18rem;
    background-size: 11.974rem 18rem;
    flex-direction: row-reverse;
    flex-wrap: nowrap;
    justify-content: space-around;
    /* align-items: center; */
  }
  .text {
    margin: 0;
    width: 16px;
    position: absolute;
    /* text-align: center; */
    /* writing-mode:vertical-lr */
  }
</style>



// WEBPACK FOOTER //
// src/pages/com/textPage.vue